import { render, staticRenderFns } from "./BookingCompleted.vue?vue&type=template&id=34ed8284"
import script from "./BookingCompleted.vue?vue&type=script&lang=js"
export * from "./BookingCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports